module.exports = __webpack_public_path__ + "public/img/img_android_down_en_2.62332677.png";